// Student v2 header container: alarms, profile; coin UI and wallet fetch only in local/dev.
import React, { useEffect, useState, useRef } from "react";
import HeaderComponent from "./Header.component";
import CoinStorePopup from "./CoinStorePopup.component";
import { useSelector } from "react-redux";
import * as AlarmApi from "api/student/v2/alarm.api";
import * as WalletApi from "api/student/v2/wallet.api";
import { useNavigate, useLocation } from "react-router-dom";

const SHOW_STUDENT_COIN_HEADER =
    process.env.REACT_APP_ENV === "local" || process.env.REACT_APP_ENV === "dev";

const HeaderContainer = (props: any) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { info: myInfo } = useSelector((state: any) => state.user);
    const [showAlarmTooltip, setShowAlarmTooltip] = useState(false);
    const [unreadCount, setUnreadCount] = useState(0);
    const [coinBalance, setCoinBalance] = useState(0);
    const [isCoinLoading, setIsCoinLoading] = useState(true);
    const [hasLoadedCoinOnce, setHasLoadedCoinOnce] = useState(false);
    const [showCoinStorePopup, setShowCoinStorePopup] = useState(false);
    const isLoadingUnreadRef = useRef(false);
    const isLoadingCoinRef = useRef(false);

    useEffect(() => {
        console.log("========================Header.container.tsx========================")
        console.log("myInfo", myInfo);
        if (myInfo.accountStatusCode === 'accountStatus:blocked' && window.location.pathname !== '/student/block') {
            navigate('/student/block', { replace: true });
        }
        console.log("========================Header.container.tsx========================")
    }, [window.location.pathname]);

    useEffect(() => {
        const fetchUnreadCount = async () => {
            // 이미 호출 중이면 재호출하지 않음
            if (isLoadingUnreadRef.current) {
                return;
            }

            try {
                isLoadingUnreadRef.current = true;
                const response = await AlarmApi.getUnreadAlarmCount();
                setUnreadCount(response.count);
            } catch (error: any) {
                console.error("읽지 않은 알람 수 조회 실패:", error);
                if (error?.errorCode === 'BLOCKED_ACCOUNT') {
                    console.error("차단된 계정입니다. 블락 페이지로 이동합니다.");
                    alert(error?.message);
                    navigate('/student/block', { replace: true });
                }
            } finally {
                isLoadingUnreadRef.current = false;
            }
        };

        // 초기 실행
        fetchUnreadCount();

        let interval: any = null;
        // 10초마다 실행
        if (process.env.REACT_APP_ENV != 'local') {
            interval = setInterval(() => {
                fetchUnreadCount();
            }, 10000);
        }

        interval = setInterval(() => {
            fetchUnreadCount();
        }, 10000);

        // 컴포넌트 언마운트 시 인터벌 정리
        return () => {
            if (interval) {
                clearInterval(interval);
            }
        };
    }, []);

    useEffect(() => {
        if (!SHOW_STUDENT_COIN_HEADER) {
            setIsCoinLoading(false);
            return;
        }
        const fetchCoinBalance = async () => {
            if (isLoadingCoinRef.current) return;
            try {
                isLoadingCoinRef.current = true;
                if (!hasLoadedCoinOnce) setIsCoinLoading(true);
                const response = await WalletApi.getBalance();
                setCoinBalance(response.balance ?? 0);
                setHasLoadedCoinOnce(true);
            } catch (error: any) {
                console.error("코인 잔액 조회 실패:", error);
            } finally {
                isLoadingCoinRef.current = false;
                setIsCoinLoading(false);
            }
        };

        fetchCoinBalance();
    }, [location.pathname]);

    const refreshCoinBalance = async () => {
        try {
            const response = await WalletApi.getBalance();
            setCoinBalance(response.balance ?? 0);
        } catch (error: any) {
            console.error("코인 잔액 조회 실패:", error);
        }
    };

    const handleAlarmClick = () => {
        setShowAlarmTooltip(!showAlarmTooltip);
        setUnreadCount(0);
    };

    const handleCloseAlarmTooltip = () => {
        setShowAlarmTooltip(false);
    };

    const handleCoinClick = () => {
        setShowCoinStorePopup(true);
    };

    const handleCloseCoinStorePopup = () => {
        setShowCoinStorePopup(false);
    };

    return (
        <>
            <HeaderComponent
                userInfo={myInfo}
                showAlarmTooltip={showAlarmTooltip}
                onAlarmClick={handleAlarmClick}
                onCloseAlarmTooltip={handleCloseAlarmTooltip}
                unreadCount={unreadCount}
                showCoinButton={SHOW_STUDENT_COIN_HEADER}
                coinBalance={coinBalance}
                isCoinLoading={isCoinLoading}
                onCoinClick={handleCoinClick}
            />
            {SHOW_STUDENT_COIN_HEADER && showCoinStorePopup && (
                <CoinStorePopup onClose={handleCloseCoinStorePopup} coinBalance={coinBalance} onPurchaseSuccess={refreshCoinBalance} />
            )}
        </>
    );
};

export default HeaderContainer;